import { z } from "zod";

// Раздел «Хайлайты» в search params: фильтр `/highlights?show=ready&hero=7` и переход к матчу
// из разбора или списка матчей — `/highlights?match=130458882&from=analysis`. Нет параметра —
// фильтр выключен; неверное значение просто пропадает.
export const highlightsSearchSchema = z.object({
  // Только готовые клипы или только моменты без клипа.
  show: z.enum(["ready", "todo"]).optional().catch(undefined),
  hero: z.number().int().positive().optional().catch(undefined),
  // Матч, к которому прокрутить раздел и выделить его.
  match: z.number().int().positive().optional().catch(undefined),
  from: z.enum(["analysis"]).optional().catch(undefined),
});

export type HighlightsSearch = z.infer<typeof highlightsSearchSchema>;
